// extracted by mini-css-extract-plugin
export var wordContainer = "_os-0";